import { createFileRoute } from "@tanstack/react-router";
import { AdminDashboard } from "@/lib/features/admin/AdminDashboard";
export const Route = createFileRoute("/_app/admin/")({
  component: AdminDashboard
});